export default "__VITE_ASSET__OJcwvIZP__"